
import { Box } from '@mui/system';
import '../../App.css';
import { useState, useContext, useEffect } from 'react';
import styled from '@emotion/styled'
import { Grid, Popover, CircularProgress} from '@mui/material';
import { mapleLogo , fehdLogo } from '../../assets/imgs';
import { useNavigate } from 'react-router-dom';
import { useLoginMutation, useRegisterMutation, useForgotPasswordMutation, useResetPasswordMutation } from '../../features/auth/authApiSlice';
import { GlobalStateContext } from '../../store/GlobalState';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../features/auth/authSlice';
import { useTranslation } from "react-i18next";
import { useSearchParams } from 'react-router-dom';

const loginPageInputStyle = {
    height: '60px',
    width: '400px',
    borderRadius: 0,
    fontSize: 'calc(14px + 0.4vw)',
    paddingLeft: '12px',
    fontWeight: 300

}

const parentStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh"
};

const loginPageContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '630px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const loginPageResetPasswordContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '630px',
    margin: '0 auto',
    visibility: 'hidden',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageHeadingContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: '700px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageLabelContainer = styled.label`
    width: 173px;
    @media (max-width: 1080px) {
      /* Styles for small screens */
      width: 160px;
    }
    flex-wrap: wrap;
`;

const LoginPageLoginButton = styled.button`
    width: 400px;
    background: #21125B;
    color: white;
    font-size: calc(12px + 0.4vw);
    border-radius: 20px;
    height: 62px;
    font-weight: 600;
    cursor: pointer;
`

const LoginPageHeading1 = styled.p`
    font-weight: 400;
    font-size: calc(28px + 0.4vw);
    #margin-top: 200px;
    margin-bottom: 0px;
`

const LoginPageHeading2 = styled.p`
    font-weight: 600;
    border-bottom: 5px solid #21125B;
    padding-bottom: 10px;
    font-size: calc(32px + 0.4vw);
    margin-bottom: 50px;
    margin-top: 32px;
`
const WrongPassword = styled.span`
    font-size: 16px;
    color: red;
`

const Login = () => {
    const [searchParams] = useSearchParams();
    const [redirectURL] = useState<string | null>(searchParams.get('redirectURL') ? searchParams.get('redirectURL') : "");
    const { t } = useTranslation();
    const globalState = useContext(GlobalStateContext)
    const [forgotPassword] = useForgotPasswordMutation()
    const [resetPassword] = useResetPasswordMutation()
    const [login] = useLoginMutation()
    const [register] = useRegisterMutation()
    const [email, setEmail] = useState("")
    const [emailaddress, setEmailAddress] = useState<String | null>("")
    const [token, setToken] = useState<String | null>("")
    const [password, setPassword] = useState("")
    const [resetpassword, setResetPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [errorMessagerg, setErrorMessagerg] = useState("")
    const [errorMessagefp, setErrorMessagefp] = useState("")
    const [errorMessagerp, setErrorMessagerp] = useState("")
    const [alertMessage, setAlertMessage] = useState("")
    const [registervariable, setRegisterVariable] = useState<JSX.Element | string | null>("Register")
    const [fpvariable, setFPVariable] = useState<JSX.Element | string | null>("Enter")
    const [rpvariable, setRPVariable] = useState<JSX.Element | string | null>("Enter")
    const [loginvariable, setLoginVariable] = useState<JSX.Element | string | null>("Login")
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const isLoggedIn = localStorage.accessToken || globalState.accessToken;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [anchorElfp, setAnchorElfp] = useState<HTMLButtonElement | null>(null);

    const handleClickfp = (event: React.MouseEvent<HTMLButtonElement>) => {
        setErrorMessagefp("")
        setAlertMessage("")
        setAnchorElfp(event.currentTarget);
    };

    const handleClosefp = () => {
        setAnchorElfp(null);
    };

    const openfp = Boolean(anchorElfp);
    const idfp = openfp ? 'simple-popoverfp' : undefined;

    const [openrp, setOpenrp] = useState(false);


    useEffect(() => {

        if(isLoggedIn && redirectURL){
            //console.log('redirectURL' , redirectURL)
            navigate(redirectURL);
        }

        const queryParameters = new URLSearchParams(window.location.search)
        setEmailAddress(queryParameters.get("email"))
        setToken(queryParameters.get("token"))
        // var arr = window.location.search.split('?');
        // if (arr.length > 1 && arr[1] !== '') {
        //     setOpenrp(true)
        // }else{
        //     setOpenrp(false)
        // }
    }, [])

    const idrp = openrp ? 'simple-popoverrp' : undefined;

    const handleKeyDown = async function (e: any) {
        if (e.key === 'Enter') {
            await handleLogin(e)
        }
    }

    const handleResetPassword = async (e: any) => {
        e.preventDefault()
        setRPVariable(<CircularProgress color="inherit"/>)
        if (resetpassword === ""){
            alert("Cannot empty password.")
            setRPVariable("Enter")
        }

        else {
            try {
                await resetPassword({ email: emailaddress, password: resetpassword, token: token }).unwrap().then(
                    () => {
                        alert("Password has been successfully changed")
                        setRPVariable("Enter")
                    }
                )
                setOpenrp(false)
            } catch (err: any) {
                console.log(err);
                setErrorMessagerp("There is something goes wrong")
                setRPVariable("Enter")
            }
        }

    }

    const handleForgotPassword = async (e: any) => {
        e.preventDefault()
        setFPVariable(<CircularProgress color="inherit"/>)
        if (email === ""){
            alert("Cannot empty email.")
            setFPVariable("Enter")
        }
        else {
            try {
                await forgotPassword({ email: email }).unwrap().then(
                    () => {
                        setAlertMessage("Email sent! Please check email for forgotpassword.")
                        setFPVariable("Enter")
                    }
                )
            } catch (err: any) {
                console.log(err);
                setErrorMessagefp("Cannot use this email.")
                setFPVariable("Enter")
            }
        }

    }

    const handleLogin = async (e: any) => {
        e.preventDefault()
        setLoginVariable(<CircularProgress color="inherit"/>)
        try {
            // var userData;
            // userData = await login({ email: email, password: password }).unwrap().then(
            await login({ email: email, password: password }).unwrap().then(
                (result) => {
                    setLoginVariable("Login")
                    const loginResponse = JSON.parse(result);
                    const { accessToken, refreshToken } = loginResponse;
                    const { token: refreshTokenToken, expires: refreshTokenExpires } = refreshToken;
                    dispatch(
                        setCredentials({
                            user: email,
                            refreshToken: refreshTokenToken,
                            accessToken: accessToken,
                            expires: refreshTokenExpires
                        })
                    );
                    localStorage.setItem('user', email);
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshTokenToken);
                    localStorage.setItem('expires', refreshTokenExpires);

                    globalState.setAccessToken(accessToken)
                    globalState.setRefreshToken(refreshTokenToken)
                    globalState.setExpires(refreshTokenExpires)
                }
            )
            setEmail('')
            setPassword('')

            redirectURL ? navigate(redirectURL) : navigate('/recordDetail/latest')
        } catch (err: any) {
            console.log(err);
            setErrorMessage("Wrong password or email.")
            setLoginVariable("Login")
        }
    }

    const handleRegister = async (e: any) => {
        e.preventDefault()
        setRegisterVariable(<CircularProgress color="inherit"/>)
        if (email === ""){
            alert("Cannot empty email.")
            setRegisterVariable("Register")
        }
        else if (password === ""){
            alert("Cannot empty password.")
            setRegisterVariable("Register")
        }
        else {
            try {
                await register({ email: email, password: password }).unwrap().then(
                    () => {

                        alert("Account has been successfully created.")
                        setRegisterVariable("Register")
                    }
                )
                setAnchorEl(null);
            } catch (err: any) {
                console.log(err);
                setErrorMessagerg("Cannot use this email.")
                setRegisterVariable("Register")
            }
        }

    }

    return (
        <>
            <Grid style={parentStyle} container spacing={0}>
                {/* <Grid item xs={12} md={6}> */}
                    {/* Photo */}
                    {/* <LoginPageImage src={loginPageImage} alt="login page photo" /> */}
                {/* </Grid> */}
                <Grid item xs={12} md={6}>
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <img src={mapleLogo} alt="" />
                        <img src={fehdLogo} width="200" height="200" alt="" />
                    </Box>
                    {/* Titles */}
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading1>{t("360 Degrees Camera System for Coastal")}</LoginPageHeading1>
                    </Box>
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("Login")}</LoginPageHeading2>
                    </Box>

                    {/* Input Boxes */}
                    <Box sx={loginPageContainerStyle}>
                        <LoginPageLabelContainer>{("Username:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                        <input name="passowrd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessage}</WrongPassword>
                    </Box>

                    {/* Buttons */}
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleLogin}>{loginvariable}</LoginPageLoginButton>
                    </Box>

                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleClickfp}>{t("ForgotPassword")}</LoginPageLoginButton>
                    </Box>
                    <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorReference={"none"}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backdropFilter: "blur(5px)",
                    }}
                    >
                    <div
                        style={{
                        margin:"30px"
                        }}
                    >
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("Register")}</LoginPageHeading2>
                    </Box>
                    <Box sx={loginPageContainerStyle}>
                        <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle}/>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                        <input name="passowrd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={loginPageInputStyle}/>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessagerg}</WrongPassword>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleRegister}>{registervariable}</LoginPageLoginButton>
                    </Box>
                    </div>
                    </Popover>

                    <Popover
                    id={idfp}
                    open={openfp}
                    anchorEl={anchorElfp}
                    onClose={handleClosefp}
                    anchorReference={"none"}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backdropFilter: "blur(5px)",
                    }}
                    >
                    <div
                        style={{
                        margin:"30px"
                        }}
                    >
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("ForgotPassword")}</LoginPageHeading2>
                    </Box>
                    <Box sx={loginPageContainerStyle}>
                        <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle}/>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessagefp}</WrongPassword>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{alertMessage}</WrongPassword>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleForgotPassword}>{fpvariable}</LoginPageLoginButton>
                    </Box>
                    </div>
                    </Popover>


                    <Popover
                    id={idrp}
                    open={openrp}
                    anchorReference={"none"}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backdropFilter: "blur(5px)",
                    }}
                    >
                    <div
                        style={{
                        margin:"30px"
                        }}
                    >
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("ResetPassword")}</LoginPageHeading2>
                    </Box>
                    <Box sx={loginPageContainerStyle}>
                        <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={emailaddress as string | number | readonly string[] | undefined} onChange={(e) => setEmailAddress(e.target.value)} style={loginPageInputStyle} disabled/>
                    </Box>
                    <Box sx={loginPageResetPasswordContainerStyle}>
                        <LoginPageLabelContainer>{("Token:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={token as string | number | readonly string[] | undefined} onChange={(e) => setToken(e.target.value)} style={loginPageInputStyle}/>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                        <input name="passowrd" type="password" value={resetpassword} onChange={(e) => setResetPassword(e.target.value)} style={loginPageInputStyle}/>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessagerp}</WrongPassword>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{alertMessage}</WrongPassword>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleResetPassword}>{rpvariable}</LoginPageLoginButton>
                    </Box>
                    </div>
                    </Popover>
                </Grid>
            </Grid>
        </>
    );
};

export default Login;
